// extracted by mini-css-extract-plugin
export default {"cta":"SI-z","disabled":"TI-z"};